const Terms = () => {

    return (
      <div>
        <h1>Vilkor</h1>  
      </div>
    );
  };
  
  export default Terms;